import type { ReactNode } from 'react';
import { CardResizeSessionContext, type CardResizeSession } from './card-resize-session';

export function CardResizeSessionProvider({
  value,
  children,
}: {
  readonly value: CardResizeSession;
  readonly children: ReactNode;
}) {
  return <CardResizeSessionContext value={value}>{children}</CardResizeSessionContext>;
}
